import { Reveal } from "./Reveal";

const BRANDS = [
    "Olaplex",
    "Kérastase",
    "Wella Professionals",
    "Redken",
    "L'Oréal Professionnel",
];

export default function Products() {
    return (
        <section
            id="produse"
            data-testid="products"
            className="px-6 py-32 md:px-12 md:py-52"
        >
            <div className="mx-auto grid max-w-6xl items-center gap-16 md:grid-cols-2 md:gap-28">
                {/* Text */}
                <div>
                    <Reveal>
                        <span className="eyebrow">Produse</span>
                        <h2
                            className="mt-5 font-serif font-light leading-[1.0]"
                            style={{ fontSize: "clamp(2.2rem, 5vw, 4rem)" }}
                        >
                            Numai produse
                            <br />
                            profesionale
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p
                            className="mt-8 max-w-md font-sans text-sm leading-relaxed"
                            style={{ color: "var(--muted-foreground)" }}
                        >
                            Alegem game care protejează firul în timpul culorii și
                            îl hrănesc după. Fără compromisuri, doar branduri în
                            care avem încredere.
                        </p>
                    </Reveal>

                    <div className="mt-12 flex flex-col">
                        {BRANDS.map((b, i) => (
                            <Reveal key={b} delay={0.05 * i}>
                                <div
                                    className="flex items-baseline justify-between border-t py-5"
                                    style={{ borderColor: "var(--line)" }}
                                >
                                    <span
                                        className="font-serif font-light"
                                        style={{
                                            fontSize: "clamp(1.4rem, 3vw, 2rem)",
                                        }}
                                    >
                                        {b}
                                    </span>
                                    <span
                                        className="eyebrow"
                                        style={{ color: "var(--accent)" }}
                                    >
                                        0{i + 1}
                                    </span>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                {/* Spotlight image with clipped frame */}
                <Reveal delay={0.15} y={40}>
                    <div className="relative">
                        <div
                            className="absolute -left-5 -top-5 h-full w-full md:-left-8 md:-top-8"
                            style={{ backgroundColor: "var(--bg-2)" }}
                        />
                        <div className="group relative overflow-hidden">
                            <img
                                src="/photos/img13.webp"
                                alt="Detaliu de culoare LadyArt"
                                className="zoomable w-full object-cover"
                                style={{ aspectRatio: "3 / 4" }}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
